import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { billPropTypes } from 'types/billTypes';
import UTDownloadBill from 'app/components/UTDownloadBill';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

import BillDetail from './components/BillDetail';
import stylesJS from './styles';
import styles from './styles.module.scss';

function LastBill({ bill, onDownloadBill }) {
  const billFields = [
    { title: message('AccountStatus:period'), text: bill.period },
    { title: message('AccountStatus:periodStartedOn'), text: bill.period_started_on },
    {
      title: `${message('AccountStatus:amount')} (${message('AccountStatus:since')} ${
        bill.first_expiration_on
      })`,
      text: bill.amount
    },
    { title: message('AccountStatus:consumption'), text: bill.consumption },
    { title: message('AccountStatus:periodEndedOn'), text: bill.period_ended_on },
    {
      title: `${message('AccountStatus:surchargeAmount')} (${message('AccountStatus:since')} ${
        bill.second_expiration_on
      })`,
      text: bill.surcharge_amount
    }
  ];

  const downloadRenderer = (
    <UTDownloadBill
      loadingMessage={message('Bill:loadingBill')}
      title={message('Bills:bill')}
      downloadUrl={bill.printedBill}
      onClickDownload={onDownloadBill}
      billId={appConfig.bills.billDownloadOnPDF ? bill.external_id : bill.id}
      disabled={!bill.downloadable}
      useIcon={appConfig.bills.downloadIcon}
      labelButton={!appConfig.bills.downloadIcon && message('AccountStatus:downloadBill')}
      period={bill.period}
      amount={bill.amount}
      className={styles.downloadButton}
    />
  );

  return (
    <div style={appConfig.lineSections ? stylesJS.lineContainer : stylesJS.colorContainer}>
      <div style={stylesJS.sectionTitle}>
        <UTLabel large bold>
          {message('AccountStatus:lastBill')}
        </UTLabel>
        {appConfig.bills.downloadIcon && downloadRenderer}
      </div>
      <div style={stylesJS.detailsWrapper}>
        <div style={stylesJS.detailsContainer}>
          {billFields.map(field => (
            <BillDetail key={field.title} title={field.title} text={field.text} />
          ))}
        </div>
        {!appConfig.bills.downloadIcon && downloadRenderer}
      </div>
    </div>
  );
}

LastBill.propTypes = {
  bill: billPropTypes,
  onDownloadBill: PropTypes.func.isRequired
};

export default Radium(LastBill);
